import { render, staticRenderFns } from "./AdministrationMenu.vue?vue&type=template&id=753d5f69&scoped=true&"
import script from "./AdministrationMenu.vue?vue&type=script&lang=ts&"
export * from "./AdministrationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753d5f69",
  null
  
)

export default component.exports